var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { justify: "center", dense: "" } },
    [
      _c(
        "v-col",
        { attrs: { sm: "6", cols: "12" } },
        [
          _c("v-select", {
            attrs: {
              "error-messages": _vm.modelTransportTypeValidation,
              items: _vm.transportTypes,
              label: _vm.$t(
                "delegation.form.fields.transport.transportType.name"
              ),
              "item-text": "name",
              "item-value": "id",
              readonly: _vm.$store.state.Delegation.readonly === true,
              "persistent-hint": "",
              hint: _vm.validationTransportType,
              "background-color":
                _vm.validationTransportType !== null ? "blue lighten-5" : null
            },
            model: {
              value: _vm.contextTransportType,
              callback: function($$v) {
                _vm.contextTransportType = $$v
              },
              expression: "contextTransportType"
            }
          })
        ],
        1
      ),
      _vm.modelTransportType === 1
        ? _c(
            "v-col",
            { attrs: { sm: "6", cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  "error-messages": _vm.modelVehicleIdValidation,
                  items: _vm.vehicles,
                  label: _vm.$t(
                    "delegation.form.fields.transport.vehicle.name"
                  ),
                  placeholder: _vm.vehiclePlaceholder,
                  "item-text": "fullName",
                  "item-value": "id",
                  readonly: _vm.$store.state.Delegation.readonly === true
                },
                model: {
                  value: _vm.contextVehicleId,
                  callback: function($$v) {
                    _vm.contextVehicleId = $$v
                  },
                  expression: "contextVehicleId"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.modelTransportType !== 1
        ? _c(
            "v-col",
            { attrs: { sm: "6", cols: "12" } },
            [
              _c("v-select", {
                attrs: {
                  "error-messages": _vm.modelSettlementTypeIdValidation,
                  items: _vm.settlementTypes(_vm.modelTransportType),
                  label: _vm.$t(
                    "delegation.form.fields.transport.settlementType.name"
                  ),
                  readonly: _vm.$store.state.Delegation.readonly === true
                },
                model: {
                  value: _vm.contextSettlementTypeId,
                  callback: function($$v) {
                    _vm.contextSettlementTypeId = $$v
                  },
                  expression: "contextSettlementTypeId"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "v-alert",
            {
              attrs: {
                value: _vm.isCompanyCarSet,
                color: "info",
                icon: "info",
                dark: ""
              }
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("delegation.form.companyVehicleAlert")) +
                  " "
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }